module.exports = __webpack_public_path__ + "img/Close - Green.0e950bbd.png";